export default [
  'เชียงราย',
  'เชียงใหม่',
  'น่าน',
  'พะเยา',
  'แพร่',
  'แม่ฮ่องสอน',
  'ลำปาง',
  'ลำพูน',
  'อุตรดิตถ์',
  'กาฬสินธุ์',
  'ขอนแก่น',
  'ชัยภูมิ',
  'นครพนม',
  'นครราชสีมา',
  'บึงกาฬ',
  'บุรีรัมย์',
  'มหาสารคาม',
  'มุกดาหาร',
  'ยโสธร',
  'ร้อยเอ็ด',
  'เลย',
  'สกลนคร',
  'สุรินทร์',
  'ศรีสะเกษ',
  'หนองคาย',
  'หนองบัวลำภู',
  'อุดรธานี',
  'อุบลราชธานี',
  'อำนาจเจริญ',

  'กรุงเทพมหานคร',
  'กำแพงเพชร',
  'ชัยนาท',
  'นครนายก',
  'นครปฐม',
  'นครสวรรค์',
  'นนทบุรี',
  'ปทุมธานี',
  'พระนครศรีอยุธยา',
  'พิจิตร',
  'พิษณุโลก',
  'เพชรบูรณ์',
  'ลพบุรี',
  'สมุทรปราการ',
  'สมุทรสงคราม',
  'สมุทรสาคร',
  'สิงห์บุรี',
  'สุโขทัย',
  'สุพรรณบุรี',
  'สระบุรี',
  'อ่างทอง',
  'อุทัยธานี',

  'จันทบุรี',
  'ฉะเชิงเทรา',
  'ชลบุรี',
  'ตราด',
  'ปราจีนบุรี',
  'ระยอง',
  'สระแก้ว',

  'กาญจนบุรี',
  'ตาก',
  'ประจวบคีรีขันธ์',
  'เพชรบุรี',
  'ราชบุรี',

  'กระบี่',
  'ชุมพร',
  'ตรัง',
  'นครศรีธรรมราช',
  'นราธิวาส',
  'ปัตตานี',
  'พังงา',
  'พัทลุง',
  'ภูเก็ต',
  'ระนอง',
  'สตูล',
  'สงขลา',
  'สุราษฎร์ธานี',
  'ยะลา'
]



// WEBPACK FOOTER //
// ./src/components/view/techhuntMaster/Province.js